
import officeApi from '../../api/officeApi';
import { calculateAttachmentHash, calculateAlternativeAttachmentHash, usingOfficeApi } from './browser';
import { getAttachments } from '../../api/emailsApi/emails';
import { changeAlertText } from '../actions';
import { isPC } from '../utils/environment';
import { Buffer } from 'buffer/';

/* global Office */
export const handleAttachmentsByPlatform = async (id, minimumFileSize, ownerEmail, dispatch, isDraft) => {
  let attachments = [];
  if (usingOfficeApi()) {
    const allAttachments = await officeApi.getAttachments();

    for (const attachment of allAttachments) {
      if (minimumFileSize && attachment.size / 1024 < minimumFileSize) {
        continue;
      }
      if (attachment.attachmentType === 'item') {
        attachment['@odata.type'] = '#microsoft.graph.itemAttachment';
      }

      let retries = 0;
      while (!attachment.hash && retries < 10) {
        try {
          const content = await officeApi.getAttachmentContent(attachment.id);

          // If the format is an eml (occurs on Mac desktop), we need to convert the content to base64 so hash matches the one generated in BE
          if (content?.value?.format === Office.MailboxEnums.AttachmentContentFormat.Eml) {
            content.value.content = Buffer.from(content.value.content, 'utf-8').toString('base64');
          }

          attachment.hash = calculateAttachmentHash(attachment.name, content.value.content);
          attachment.alternativeHash = isPC() ? calculateAlternativeAttachmentHash(attachment.name + '.eml') : calculateAlternativeAttachmentHash(attachment.name);
        } catch (e) {
          // backoff and retry
          await new Promise((resolve) => setTimeout(resolve, retries * 250));
          console.error('Error saving attachments', e);
          retries++;
        }
      }
      if (!attachment.hash) {
        dispatch(changeAlertText('Attachments failed to attach.', 'error'));
      }
      attachments.push(attachment);
    }
  } else {
    let attachmentsResponse;
    attachmentsResponse = await getAttachments(id, ownerEmail, isDraft);

    if (attachmentsResponse.jobStatus === 'pending') {
      const backgroundJob = attachmentsResponse.backgroundJobId;

      let retryCount = 0;
      const MAX_RETRIES = 20;
      if (backgroundJob) {
        while (attachmentsResponse.jobStatus === 'pending') {
          dispatch(changeAlertText('Handling large attachments, please wait.'));
          retryCount += 1;
          if (retryCount > MAX_RETRIES) {
            dispatch(changeAlertText('Failed to retrieve attachments after multiple attempts.', 'error'));
            break;
          }
          // timeout to slow down the retries
          await new Promise((resolve) => setTimeout(resolve, 1000 * retryCount));
          attachmentsResponse = await getAttachments(id, ownerEmail, isDraft, backgroundJob);
        }
      }
    } else if (attachmentsResponse.attachmentsError) {
      dispatch(changeAlertText('Failure to upload file(s), exceeds add-in limit. Upload in Docrio.', 'error'));
    }
    attachments = attachmentsResponse.attachments;
  }
  return attachments;
};
